import React from "react";
import "./footer.scss";

const Footer: React.FC = () => {
    return(
    <footer></footer>
    )
};

export default Footer;
